// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fJDa","col":"styles_col__2zaY0"};